<template>
  <v-layout wrap>
    <v-flex xs12 class="text-xs-center">
      <v-alert v-if="user.bio==''" :value="true" type="warning">Give us some information about what you do</v-alert>
      <div class="modal-vue">
        <v-btn color="btnColor" dark slot="activator" class="mb-2" flat @click="openModal">
          <v-icon>add</v-icon>Update
        </v-btn>
        <!-- overlay -->
        <div class="overlay" v-if="showModal" @click="closeModal"></div>
        <!-- modal -->
        <div class="modal" v-if="showModal" >
          <v-card>
            <v-toolbar color="primary" flat dense dark>
              <v-toolbar-title class="title">Who i am</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="mx-0" icon @click="closeModal">
                <v-icon color="white">clear</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>                
                  <v-flex xs12>                  
                    <label>About me and what i do</label>
                    <tinymce 
                      id="bio"
                      name="bio"
                      v-model="bio"
                      label="About me and what i do"
                      :other_options="tinyOptions"
                      v-on:editorInit="initCallBack"
                    ></tinymce>
                  </v-flex>
                  <v-flex xs12 sm12 v-if="tinymcError != ''" class="mb-2">
                    <span class="v-messages theme--light error--text"><strong>Min allowed text is 120 words; please add more content. </strong></span>
                  <!-- <span class="red--text" > THE MORE THE CONTENT THE BETTER THE INDEXING!</span> -->
                  </v-flex>
                  <v-flex xs12>
                    <v-btn class="btnColor" dark @click="save">
                      <v-icon left>save</v-icon>Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>            
          </v-card>
        </div>
      </div>      
    </v-flex>

    <v-flex xs12 class="pa-3" v-html="user.bio"></v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import tinymce from 'vue-tinymce-editor';
export default {
  name: "ExpertAboutIndex",
  computed: {
    ...mapGetters(["user"])
  },
  components: {
    tinymce
  },
  data() {
    return {
      showModal: false,      
      bio: null,
      tinyOptions: {
        menubar:false,
        toolbar1:"formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist | removeformat",
        branding: false
      },
      tinymcError: '',    
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
      this.bio = this.user.bio;
    },
    closeModal() {
      this.showModal = false;
    },
    initCallBack(e) {
      window.tinymce.editors["bio"].setContent(this.user.bio);
    },    
    save() {
      var count = this.countWords();
      if (count < 120) {
          this.tinymcError = 'min word error';
      } else {
        this.tinymcError = '';
        const data = {
          bio: this.bio
        };

        //dispatch
        const self = this;
        self.loader = true;
        const res = this.$store
          .dispatch("put", { url: "/user/update/" + this.user._id, data })
          .then(res => {
            self.$store.commit("setUser", res.user);
            self.loader = false;
            self.bio = null;          
            self.showModal = false;
          });
      }
      
    }, 
   countWords() {
        const wordcount = window.tinymce.activeEditor.plugins.wordcount;
        return wordcount.getCount();
        /*var body = window.tinymce.get("description").getBody();
        var content = window.tinymce.trim(body.innerText || body.textContent);
        return content.length;*/
    },
    ValidateCharacterLength() {
        var min = 600;
        var count = this.CountCharacters();
        if (count < min) {
            this.tinymcError = 'Min allowed characters is 600, please type more content';
            return false;
        }
        return;
    }   
  }
};
</script>
<style scoped>
.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.modal-vue .modal {  
  z-index: 9999;    
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*width: 750px;*/
  width: 100%;
  padding: 24px;
  max-width: 750px;
}

.modal-vue .close{
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>